import { Button } from '../ui'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui'

interface ApproveConfirmationDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
  isSubmitting?: boolean
  title?: string
  description?: string
  confirmText?: string
  cancelText?: string
}

export function ApproveConfirmationDialog({
  open,
  onOpenChange,
  onConfirm,
  isSubmitting = false,
  title = 'Approve Transaction',
  description = 'Are you sure you want to approve this transaction? This action cannot be undone.',
  confirmText = 'Approve',
  cancelText = 'Cancel',
}: ApproveConfirmationDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            variant="outline"
            className="h-10"
            onClick={() => onOpenChange(false)}
            disabled={isSubmitting}
          >
            {cancelText}
          </Button>
          <Button
            onClick={onConfirm}
            className="bg-green-600 hover:bg-green-700 h-10"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Approving...' : confirmText}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
